module.exports = __webpack_public_path__ + "images/emoji/runner.fcce534dcfdb6071cc7b.png";